import Button from '@ui/components/Button/Button'
import Icon from '@ui/components/Icon/Icon'

import styles from './WatchingStateSection.module.scss'

type WatchingStateSectionProps = {
	folderName: string
	syncedCount: number
	hasSubfolders: boolean
	onStopWatching: () => void
}

type StatusProps = Pick<WatchingStateSectionProps, 'folderName' | 'syncedCount' | 'hasSubfolders'>

const getStatusText = ( { folderName, syncedCount, hasSubfolders }: StatusProps ) => {
	const files = 'file'.pluralize( syncedCount )
	if ( hasSubfolders ) {
		if ( syncedCount === 0 ) return `Syncing files from ${folderName} and subfolders…`
		return `${syncedCount} ${files} synced from ${folderName} and subfolders`
	}
	if ( syncedCount === 0 ) return 'Watching for new files…'
	return `${syncedCount} ${files} synced this session`
}

const WatchingStateSection = ( {
	folderName, syncedCount, hasSubfolders, onStopWatching
}: WatchingStateSectionProps ) => (
	<div className={styles.WatchingStateSection}>
		<div className={styles.WatchingStateSection__info}>
			<Icon icon="folder-outlined" size={14} color="primary" />
			<div className={styles.WatchingStateSection__text}>
				<span className={styles.WatchingStateSection__folderName}>{folderName}</span>
				<span className={styles.WatchingStateSection__status}>
					{getStatusText( { folderName, syncedCount, hasSubfolders } )}
				</span>
				<span className={styles.WatchingStateSection__hint}>
					Sync runs while this tab is open
				</span>
			</div>
		</div>
		<Button size="xs" variant="outline" onClick={onStopWatching}>
			Stop watching
		</Button>
	</div>
)

export default WatchingStateSection
